
/**
 * List Controller
 */
(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.controller('AgencyIndexController', [
        '$scope',
        '$window',
        '$timeout',
        'agencyApi',
        function($scope, $window, $timeout, agencyApi) {
            // select search input content on focus
            $('#search').click(function() {
                $(this).select();
            });

            $scope.list = null;

            $scope.page = {
                number: 0,
                size: 10,
            };

            $scope.searchTerm = '';

            $scope.sort = {
                field: 'ts_updated',
                order: 'desc',
            };

            var filterTimeout = null;
            $scope.$watch('searchTerm', function(newVal, oldVal) {
                if (newVal == oldVal) {
                    return;
                }

                if (filterTimeout) {
                    $timeout.cancel(filterTimeout);
                }

                filterTimeout = $timeout(function() {
                    $scope.page.number = 0;

                    $scope.fetch();
                }, 700);
            });

            $scope.getStatus = function(status) {
                return status ? 'Active' : 'Inactive';
            };

            $scope.openAgencyForm = function(agencyId) {
                $window.location.href = '/#!/demandmgr/agency/edit?id=' + agencyId;
            };

            $scope.canBeDeleted = function(agency) {
                for (var i = 0; i < $scope.list.data.length; i++) {
                    if ($scope.list.data[i].agency_ref === agency._id) {
                        // check if any other agency is referenced to the given one
                        return false;
                    }
                }

                // check if agency has no related clients, advertisers or ios
                return agency['can_be_deleted'];
            };

            /**
             * Fetch list data from server
             */
            $scope.fetch = function() {
                $scope.loading = true;

                agencyApi.getList($scope.sort, $scope.searchTerm, $scope.page).then(
                    function(data) {
                        $scope.list = {
                            count: data.count,
                            data: data.data,
                            maxPage: Math.floor(data.count / $scope.page.size),
                        };
                        $scope.loading = false;
                    },
                    function() {
                        $scope.list = {
                            count: 0,
                            data: [],
                            maxPage: null,
                        };
                        $scope.loading = false;
                    }
                );
            };

            /**
             * set page to new value and load data
             * @param page
             */
            $scope.setPage = function(page) {
                $scope.page.number = page;

                $scope.fetch();
            };

            /**
             * get the sort css for a given column
             * @param field
             * @returns {*}
             */
            $scope.getSortCssClass = function(field) {
                if ($scope.sort.field === field) {
                    return 'fa-sort-' + $scope.sort.order;
                } else {
                    return 'fa-sort';
                }
            };

            /**
             * update sorting and fetch data
             * @param field
             */
            $scope.setSort = function(field) {
                $scope.page.number = 0;

                if ($scope.sort.field === field) {
                    $scope.sort.order = $scope.sort.order === 'desc' ? 'asc' : 'desc';
                } else {
                    $scope.sort.field = field;
                    $scope.sort.order = 'desc';
                }

                $scope.fetch();
            };

            /**
             * show the delete confirmation dialog
             * @param agency
             */
            $scope.promptDelete = function(agency) {
                $scope.agencyToDelete = agency;
                $('#delete-modal').modal('show');
            };

            /**
             * delete an Agency
             * @param agency
             */
            $scope.delete = function(agency) {
                agencyApi.delete(agency.id).then(function() {
                    $scope.fetch();
                });
            };

            /**
             * export list to csv
             */
            $scope.export = function() {
                var url = '/demandmgr/agency/export' +
                    getReportUrl($scope.sort, $scope.searchTerm);

                window.location.href = url;
            };

            $scope.drillDown = function(id) {
                window.location.href = '/#!/demandmgr/advertiser?agency=' + id;
            };

            $scope.fetch();
        },
    ]);
})(window.angular);
